<template>
  <div class="land-home-partner">
    <el-row class="home-partner-title">优质战略合作伙伴</el-row>
    <div class="home-partner-logo">
      <el-card
        shadow="hover"
        v-for="item in PartnerList"
        :key="item.partnerImg"
        :body-style="{padding: '0px'}"
      >
        <img
          :src="item.partnerImg"
          width="100%"
        />
        <!-- <el-image
            :src="partnerImg1"
            fit="contain"
          ></el-image> -->
      </el-card>
      <el-card
        shadow="hover"
        v-show="isShow"
        :body-style="{padding: '0px'}"
      >
        <div style="width: 18px;font-size: 18px;font-weight: 400;color: #1F1F1F;line-height: 25px;">···</div>
        <!-- <el-image
            :src="partnerImg1"
            fit="contain"
          ></el-image> -->
      </el-card>
    </div>
  </div>
</template>

<script>
import { getPartnerList } from '@/api/landing'
export default {
  name: 'landHomePartner',
  mounted () {
    this.getList()
  },
  data () {
    return {
      PartnerList: [],
      isShow: false
    }
  },
  props: {},
  methods: {
    // 获取列表
    getList () {
      getPartnerList().then(res => {
        const { code, data, message } = res
        if (code === 200) {
          this.PartnerList = data || []
          if ((this.PartnerList.length % 5) === 4) {
            this.isShow = true
          } else {
            this.isShow = false
          }
        } else {
          this.PartnerList = []
          message && this.$message.error(message)
        }
      }).catch(() => {
        this.PartnerList = []
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.land-home-partner {
  width: 1250px;
  // height: 712px;
  margin: auto;
  // background: #a7abad;
  padding-top: 72px;
  margin-bottom: 74px;
  //取消竖线，内容不能被选择
  -webkit-user-select: none; /*谷歌 /Chrome*/
  -moz-user-select: none; /*火狐/Firefox*/
  -ms-user-select: none; /*IE 10+*/
  user-select: none;
  .home-partner-title {
    height: 56px;
    font-size: 40px;
    font-weight: 600;
    color: #000000;
    line-height: 56px;
    text-align: center;
  }
  .home-partner-logo {
    display: flex;
    flex-flow: wrap;
    margin-top: 50px;
    margin-left: 27px;
    ::v-deep .el-card {
      width: 223px;
      height: 70px;
      background: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.12);
      border-radius: 8px;
      margin-right: 20px;
      margin-bottom: 22px;
    }
    img {
      //   display: table-cell; //主要是这个属性
      // vertical-align: middle;
      // text-align: center;
      display: block;
      margin: auto;
    }
  }
}
</style>
